import OdmietnutieGestora from './OdmietnutieGestora';

export default OdmietnutieGestora;
